import Footer from "../../Footer";
import Navbar from "../../Navbar";
import CreateTicket from "./CreateTicket";
import Hero from "./Hero";

function SupportPage() {
    return ( 
        <>
           
            <Hero/>
            <CreateTicket/>
            
        </>
     );
}

export default SupportPage;